import { gsap, ScrollTrigger, CustomEase, screenSm } from './1.1_animations-defaults.js';
import { swiperCultureSectionB } from './4.4_swipers-culture-section-b.js';

const SECTION_ID = 'scroll-text-and-slider';
const TEXT_1_CLASS = 'text-1';
const TEXT_2_CLASS = 'text-2';
const SLIDE_CLASS = 'horizontal-slide';
const MOBILE_TEXT_CLASS = 'mobile-text-wrapper';

class AnimationsScrollTextAndSlider {
    constructor() {
        this._section = document.getElementById(SECTION_ID);
        this._section && this._run();
    }
    _run() {
        this._media = gsap.matchMedia();
        this._text1 = this._section.querySelector(`.${TEXT_1_CLASS}`);
        this._text2 = this._section.querySelector(`.${TEXT_2_CLASS}`);
        this._slide = this._section.querySelector(`.${SLIDE_CLASS}`);
        this._mobileText = this._section.querySelector(`.${MOBILE_TEXT_CLASS}`);

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline.bind(this),
        );
    }
    _createAnimationTimeline(context) {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        let easing = 'sliderEase';

        this._animation1 = gsap.timeline({
            scrollTrigger: {
                trigger: this._section,
                start: 'top top',
                end: 'bottom bottom',
                markers: false,
            },
        });

        this._animation1
            .to(
                this._text1,
                {
                    keyframes: {
                        '20%': { opacity: 1 },
                        '35%': { opacity: isDesktop ? 1 : 0 },
                        '84%': { y: '-70vh' },
                    },
                    ease: easing,
                },
                '<',
            )
            .to(
                this._text2,
                {
                    keyframes: {
                        '20%': { opacity: 1 },
                        '35%': { opacity: isDesktop ? 1 : 0 },
                        '84%': { y: '70vh' },
                    },
                    ease: easing,
                },
                '<',
            )
            .to(
                this._slide,
                {
                    keyframes: {
                        '0%': { xPercent: 0 },
                        '100%': { xPercent: -100 },
                    },
                    ease: easing,
                },
                '<',
            )
            .to(
                this._mobileText,
                {
                    keyframes: {
                        '65%': { opacity: 0, y: '5rem' },
                        '100%': { opacity: 1, y: 0 },
                    },
                    ease: easing,
                },
                '<',
            );
    }
}

const animationsScrollTextAndSlider = new AnimationsScrollTextAndSlider();
